import React from 'react';
import InfoTip from '../ui/InfoTip';

/** ⓘ « à quoi sert le code de licence » — en-tête de la liste et fiche licence. */
export default function LicenseCodeInfo() {
  return (
    <InfoTip>
      <div style={{ fontWeight: 600, marginBottom: '0.25rem', textTransform: 'none' }}>Code de licence</div>
      <div style={{ textTransform: 'none', letterSpacing: 'normal' }}>
        Identifiant unique et lisible du client (ex. SNCF, CA31). C'est lui qu'on indique pour désigner la
        licence dans la CI, l'agent de push, les scripts et l'API (publication des packages, filtres) — l'id
        numérique reste accepté mais n'est pas fait pour être saisi.
        {'\n\n'}Le modifier oblige à mettre à jour les jobs et scripts qui l'utilisent.
      </div>
    </InfoTip>
  );
}
